import { makeVar } from '@apollo/client';
import { TTeamInputPartial } from 'Models/teams/isTeamInput';

export const teamInputVar = makeVar<TTeamInputPartial>({});
export const editingTeamIdVar = makeVar<string | null>(null);
